import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  ListChecksIcon,
  PaperPlaneIcon,
  PencilSimpleLineIcon,
  ThumbsUpIcon,
} from 'app/components/shared/icons';

import useResourcesReset from '../../hooks/useResourcesReset';
import {
  ResourcesFilterBarInstructionsInformationContainer,
  ResourcesFilterBarInstructionsInformationDescription,
  ResourcesFilterBarInstructionsInformationTitle,
  ResourcesFilterBarInstructionsItem,
  ResourcesFilterBarInstructionsItemIcon,
  ResourcesFilterBarInstructionsTitle,
  ResourcesFilterBarInstructionsWrapper,
} from './styled';

export default function ResourcesFilterBarInstructions() {
  const { push } = useHistory();
  const reset = useResourcesReset();

  const handleSearchClick = () => {
    reset();
    if (window.location.pathname !== '/resources') {
      push('/resources');
    }
  };

  return (
    <ResourcesFilterBarInstructionsWrapper>
      <ResourcesFilterBarInstructionsTitle>GETTING STARTED</ResourcesFilterBarInstructionsTitle>
      <ResourcesFilterBarInstructionsItem clickable onClick={handleSearchClick}>
        <ResourcesFilterBarInstructionsItemIcon>
          <PaperPlaneIcon width={20} height={20} fill="var(--color-primary)" />
        </ResourcesFilterBarInstructionsItemIcon>
        <ResourcesFilterBarInstructionsInformationContainer>
          <ResourcesFilterBarInstructionsInformationTitle>
            SEARCH
          </ResourcesFilterBarInstructionsInformationTitle>
          <ResourcesFilterBarInstructionsInformationDescription>
            Type in what you’re looking for in everyday language
          </ResourcesFilterBarInstructionsInformationDescription>
        </ResourcesFilterBarInstructionsInformationContainer>
      </ResourcesFilterBarInstructionsItem>
      <ResourcesFilterBarInstructionsItem>
        <ResourcesFilterBarInstructionsItemIcon>
          <ListChecksIcon width={20} height={20} fill="var(--color-primary)" />
        </ResourcesFilterBarInstructionsItemIcon>
        <ResourcesFilterBarInstructionsInformationContainer>
          <ResourcesFilterBarInstructionsInformationTitle>
            RESEARCH
          </ResourcesFilterBarInstructionsInformationTitle>
          <ResourcesFilterBarInstructionsInformationDescription>
            Click on resources to learn more
          </ResourcesFilterBarInstructionsInformationDescription>
        </ResourcesFilterBarInstructionsInformationContainer>
      </ResourcesFilterBarInstructionsItem>
      <ResourcesFilterBarInstructionsItem>
        <ResourcesFilterBarInstructionsItemIcon>
          <PencilSimpleLineIcon width={20} height={20} fill="var(--color-primary)" />
        </ResourcesFilterBarInstructionsItemIcon>
        <ResourcesFilterBarInstructionsInformationContainer>
          <ResourcesFilterBarInstructionsInformationTitle>
            CONNECT
          </ResourcesFilterBarInstructionsInformationTitle>
          <ResourcesFilterBarInstructionsInformationDescription>
            Leave a question, build upon the materials or click on the contributor to send an email
            to them{' '}
          </ResourcesFilterBarInstructionsInformationDescription>
        </ResourcesFilterBarInstructionsInformationContainer>
      </ResourcesFilterBarInstructionsItem>
    </ResourcesFilterBarInstructionsWrapper>
  );
}
